import { useEffect, useState, type RefObject } from "react";

type Options = {
  /** Once visible, stay visible. Defaults to false (tracks scroll continuously). */
  once?: boolean;
};

export function useIsVisible(
  ref: RefObject<Element | null>,
  { once = false }: Options = {}
) {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const target = ref.current;
    if (!target) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIntersecting(true);
        if (once) observer.disconnect();
      } else if (!once) {
        setIntersecting(false);
      }
    });

    observer.observe(target);
    return () => observer.disconnect();
  }, [ref, once]);

  return isIntersecting;
}
